import React from 'react';

const Sidebar = () => {
  return (
    <div className="xs-sidebar-group info-group info-sidebar">
      <div className="xs-overlay xs-bg-black"></div>
      <div className="xs-sidebar-widget">
        <div className="sidebar-widget-container">
          <div className="widget-heading">
            <a href="#" className="close-side-widget">X</a>
          </div>
          <div className="sidebar-textwidget">
            <div className="sidebar-info-contents">
              <div className="content-inner">
                <div className="logo">
               
                <a href="/"><img src="assets/images/Rayyan Aid Logo-03.png" alt="Rayyan Aid logo" style={{ height: '100px', width: 'auto', verticalAlign: 'middle' }} /></a>
                <a href="/" className="main-menu__brand" style={{ marginLeft: '0px', display: 'inline-block', verticalAlign: 'middle', fontWeight: 800, fontSize: '24px', color: '#ffffff', textDecoration: 'none' }}>Rayyan Aid</a>
             
                </div>
                <div className="content-box">
                  <h4>About Us</h4>
                  <div className="inner-text">
                    <p>Rayyan Aid is a non‑profit organization serving communities with dignity
                      across education, healthcare, nutrition and emergency relief. We work side‑by‑side
                      with local partners to deliver transparent, measurable impact.
                    </p>
                  </div>
                </div>

                <div className="form-inner">
                  <h4>Get in touch</h4>
                  <form action="/contact" method="post">
                    <div className="form-group">
                      <input type="text" name="name" placeholder="Name" required="" />
                    </div>
                    <div className="form-group">
                      <input type="email" name="email" placeholder="Email" required="" />
                    </div>
                    <div className="form-group">
                      <textarea name="message" placeholder="Message..."></textarea>
                    </div>
                    <div className="form-group message-btn">
                      <button className="thm-btn" type="submit" data-loading-text="Please wait...">
                        <span className="thm-btn-text">Send Message</span>
                        <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                      </button>
                    </div>
                  </form>
                </div>

                <div className="sidebar-contact-info">
                  <h4>Contact Info</h4>
                  <ul className="list-unstyled">
                    <li>
                      <span className="icon-pin"></span> Abuja, Nigeria
                    </li>
                    <li>
                      <span className="icon-call"></span>
                      <a href="tel:07063653772">07063653772</a>
                    </li>
                    <li>
                      <span className="icon-email"></span>
                      <a href="mailto:info@rayyanaid.org">info@rayyanaid.org</a>
                    </li>
                  </ul>
                </div>
                <div className="thm-social-link1">
                  <ul className="social-box list-unstyled">
                    <li>
                      <a href="https://facebook.com/rayyanaid" target="_blank" rel="noopener noreferrer"><i className="icon-facebook-app-symbol" aria-hidden="true"></i></a>
                    </li>
                    <li>
                      <a href="https://twitter.com/rayyanaid" target="_blank" rel="noopener noreferrer"><i className="icon-twitter" aria-hidden="true"></i></a>
                    </li>
                    <li>
                      <a href="https://instagram.com/rayyanaid" target="_blank" rel="noopener noreferrer"><i className="icon-instagram" aria-hidden="true"></i></a>
                    </li>
                    <li>
                      <a href="https://www.pinterest.com/rayyanaid" target="_blank" rel="noopener noreferrer"><i className="icon-pinterest" aria-hidden="true"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      
</div>
    </div>
  );
};

export default Sidebar;
